import styled from "styled-components";
import { IconButton } from "@mui/material";

export const Container = styled.div`
  background-color: #fff;
  box-shadow: 0px 2px 4px 0px rgba(48, 48, 48, 0.12);
  padding: 16px;
  border-radius: 16px;
  border: 1px solid rgba(213, 213, 213, 0.3);
`;

export const ColumnFlex = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const RowGap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap; /* Adicione esta linha */
`;

export const Title = styled.p`
  color: #333;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.18px;
  margin-bottom: 16px;
`;

export const Text: any = styled.p`
  color: rgba(0, 0, 0, 0.87);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;

  word-break: break-all;
  word-wrap: break-word;
`;

export const TextDesc: any = styled.p`
  color: rgba(0, 0, 0, 0.87);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.16px;
  ${(props: any) =>
    props.mostrarTudo &&
    `
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
  `}
  word-break: break-all;
  word-wrap: break-word;
`;

export const BotaoMostrarMais = styled.button`
  background: transparent;
  cursor: pointer;
  p {
    color: rgba(0, 0, 0, 0.87);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.16px;
    text-decoration: underline;
  }
`;

export const ButtonRightWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  flex: 1;
  margin-top: 16px;
`;

export const MessageWrapper = styled.div`
  background: rgba(213, 213, 213, 0.1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-top: 16px;
`;

export const MessageTitle = styled.p`
  color: #646363;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
  letter-spacing: -0.16px;
`;

export const SpaceY: any = styled.p`
  height: ${(props: any) => props?.space}px;
`;

export const Badge: any = styled.div`
  display: flex;
  min-width: 136px;
  height: 29px;
  padding: 1px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: ${(props: any) => props?.color};
  border-radius: 16px;
`;

export const BadgeText: any = styled.div`
  color: ${(props: any) => props?.color};
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const Button: any = styled(IconButton)`
  background-color: ${(props: any) => props?.color} !important;
  border-radius: 8px !important;
  height: 40px !important;
  width: 40px !important;
`;
